export default {
  allMemberships: {},
  selectedMembership: {},
  verification: {},
  singleMembership: {},
};
